module.exports = __webpack_public_path__ + "static/img/share-hint.f004315.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/share-hint.png
// module id = 1216
// module chunks = 148